import { render, staticRenderFns } from "./m-recordetail.vue?vue&type=template&id=5064303c&scoped=true&"
import script from "./m-recordetail.vue?vue&type=script&lang=js&"
export * from "./m-recordetail.vue?vue&type=script&lang=js&"
import style0 from "./m-recordetail.vue?vue&type=style&index=0&id=5064303c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5064303c",
  null
  
)

export default component.exports